<div mat-dialog-content>
  <form [formGroup]="formPack">
    <mat-form-field class="form-field-maxi space-h-l">
      <mat-label>{{ 'TITLE' | translate }}</mat-label>
      <input
        id="PacksModifyTitleModifyTxt"
        matInput
        formControlName="title"
        required
        (ngModelChange)="bineratorLenghtTest('title')"
        (blur)="bineratorLenghtTestOnFocus('title')"
      />
      <mat-error *ngIf="formPack.controls.title.hasError('required')"> {{ 'TITLE_REQUIRED' | translate }} </mat-error>
      <mat-error *ngIf="formPack.controls.title.hasError('binerator')"> {{ 'BINERATOR.RULES.TITLE.TOO_LONG' | translate }} </mat-error>
    </mat-form-field>
  </form>
</div>

<div mat-dialog-actions>
  <button class="space-h-s btn-warn" id="PacksModifyTitleCancelBtn" style="margin-left: auto" mat-raised-button (click)="cancel()">
    {{ 'CANCEL' | translate }}
  </button>
  <button
    class="space-h-s btn-submit"
    id="PacksModifyTitleSaveBtn"
    mat-raised-button
    (click)="submitSelection()"
    [disabled]="formPack.invalid"
  >
    {{ 'SAVE' | translate }}
  </button>
</div>
